import { useEffect, useState } from 'react';
import auth from '../../../utils/auth';

// How many seconds from refresh token expiration to display timout warning modal.
const TIMEOUT_WARNING_THRESHOLD = 300;
// How often to check time left on refresh token.
const CHECK_INTERVAL = 1000;

const useAuthTimeout = () => {
  const [thresholdReached, setThresholdReached] = useState(false);
  const [expired, setExpired] = useState(false);

  const handleRefresh = () => {
    if (expired) {
      auth.login();
    } else {
      auth
        .updateToken(TIMEOUT_WARNING_THRESHOLD)
        .then(() => {
          setExpired(false);
          setThresholdReached(false);
        })
        .catch(() => {
          if (!auth.authenticated) {
            auth.login();
          }
        });
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const hasReachedThreshold = auth.isRefreshTokenExpired(
        TIMEOUT_WARNING_THRESHOLD
      );
      const hasExpired = auth.isRefreshTokenExpired();
      setThresholdReached(hasReachedThreshold);
      setExpired(hasExpired);
    }, CHECK_INTERVAL);

    return () => clearInterval(interval);
  }, []);

  return {
    thresholdReached,
    expired,
    handleRefresh
  };
};

export default useAuthTimeout;
